import React, {Component} from 'react';
import autobind from "autobind-decorator";
import * as InitStatus from "../../../constants/common/InitializationStatus";
import fetch from "fetch-retry";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import {number_format} from '../../../utils/formatter';
import If from "../../common/control/If";
import Loading from "../../common/Loading";
import moment from "moment/moment";
import {addPrefix} from "../../../utils/UriUtil"

class RefferDomain extends Component {

  constructor(props) {
    super(props);
    this.state = this.initState();
  }

  initState() {
    return {
      topDomainList: [],
      apiStatus: InitStatus.INIT_READY
    }
  }

  componentDidMount() {
    this.getTopRefDomain();
  }

  @autobind
  getTopRefDomain() {
    this.setState({apiStatus: InitStatus.INIT_DOING}, () => {
      const {dispatch} = this.props;
      fetch(addPrefix(`/manage/statistics/referrer/top/domain.json`), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        retries: 2,
        retryDelay: 300,
        retryOn: [500]
      })
        .then(jsonResponseHandler(dispatch))
        .then(res => res.json())
        .then(res => {
          const list = res.data.hasOwnProperty('result') ? res.data.result : [];
          const lastUpdateTime = res.data.hasOwnProperty('lastUpdateTime') ? res.data.lastUpdateTime : null;

          this.setState({
            topDomainList: list,
            apiStatus: InitStatus.INIT_SUCCESS
          });

          // 캐시 갱신 시간 부모 Component에게 전달
          if (lastUpdateTime != null) this.props.handleSetLastUpdateTime(moment(lastUpdateTime).format("YYYY-MM-DD HH:mm"));

        })
        .catch(e => {
          this.setState({topDomainListtatus: InitStatus.INIT_FAIL});
          console.error('error', e);
          alert('통계 정보를 조회할 수 없습니다. 잠시 후 다시 시도해 주시기 바랍니다.');
        });
    });

  }


  // items 렌더링
  renderItems(list) {
    return list.map((item, index) => {
      return <li key={index}>
        <em className="rank_g">{index + 1}</em>
        <span className="txt_g"><span>{item.domain}</span></span>
        <span className="num_g">{number_format(item.pv)}</span>
      </li>
    });
  }

  renderEmpty() {
    return <p className="noti_empty">유입된 경로가 없습니다.</p>;
  }

  render() {
    const {topDomainList, apiStatus} = this.state;
    const {isDoing, isFail, isEmpty, isSuccess} = InitStatus.init(apiStatus, topDomainList);
    return (
      <div className="box_blog box_log">
        <h4 className="tit_sub">순위</h4>
        <If condition={isEmpty}>{this.renderEmpty()}</If>
        <If condition={!isEmpty}>
          <ol className="list_rank">{this.renderItems(topDomainList)}</ol>
        </If>
        <If condition={isDoing}><Loading/></If>
      </div>
    );
  }
}

export default RefferDomain;
